import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import io from "socket.io-client";
import {
  Layout,
  Drawer,
  Affix,
  Spin,
  notification as antDNotification,
} from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  removeGLobalAppNotification,
  resetAppNotification,
  openDrawerFilter,
} from "../../store/actions/app-actions";

import { fetchSystemNotifications } from "../../store/actions/settings-actions";
import { socketAuth } from "../../store/api/socketAuth";

const { Header: AntHeader, Content, Sider } = Layout;

const Context = React.createContext({
  name: "Default",
});

const socket = io(process.env.REACT_APP_API_URL, { auth: socketAuth });

function Main(props) {
  const subName = props?.children?.props?.subName;
  const currentUser = useSelector((state) => state.auth.user);
  const {
    globalSyncedInProgress,
    showDrawerFilter,
    filterDrawerContent,
    drawerFilterHeader,
    filterDrawerSize,
  } = useSelector((state) => state.app);
  const contextValue = useMemo(
    () => ({
      name: "LendTree",
    }),
    []
  );

  const { systemNotification } = useSelector((state) => state.systemSettings);

  const dispatch = useDispatch();
  const { children } = props;
  const [visible, setVisible] = useState(false);
  const [placement] = useState("left");
  const [sidenavColor, setSidenavColor] = useState("#7E2BF5");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(true);

  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  const { notifications } = useSelector((state) => state?.app);
  const [api, contextHolder] = antDNotification.useNotification();

  let { pathname } = useLocation();
  // pathname = pathname.replace("/", "");
  const crumbName = pathname.split("/")[1];

  const openNotification = (notif) => {
    const { message, placement = "top", id, type } = notif;
    api[type]({
      message: `${message}`,
      placement,
      onClose: () => {
        dispatch(removeGLobalAppNotification(id));
      },
    });
  };

  //notifications
  useEffect(() => {
    if (notifications.length > 0 && openNotification) {
      const lastNotification = notifications[notifications.length - 1];
      dispatch(resetAppNotification());
      openNotification(lastNotification);
    }
    // eslint-disable-next-line
  }, [notifications]);

  useEffect(() => {
    // console.log(systemNotification.notifications)
    if (
      systemNotification.notifications?.length <= 0 ||
      systemNotification.notifications === undefined
    ) {
      dispatch(
        fetchSystemNotifications({
          sort: "createdAt,desc",
          clientEmail: currentUser.email,
        })
      );
    }

    // Listen for new notifications from the server
    socket.on("newNotification", (notification) => {
      dispatch(
        fetchSystemNotifications({
          sort: "createdAt,desc",
          clientEmail: currentUser.email,
        })
      );
    });

    return () => {
      // Clean up event listener when component unmounts
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (pathname === "rtl") {
  //     setPlacement("left");
  //   } else {
  //     setPlacement("right");
  //   }
  // }, [pathname]);

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Spin
        spinning={globalSyncedInProgress}
        fullscreen
        tip="Fetching records update..."
      >
        <Layout
          className={`layout-dashboard ${
            pathname === "profile" ? "layout-profile" : ""
          } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
        >
          <Drawer
            title={false}
            placement={placement === "right" ? "right" : "left"}
            closable={false}
            onClose={() => setVisible(false)}
            open={visible}
            key={placement === "right" ? "right" : "left"}
            width={250}
            className={`drawer-sidebar 
          } `}
          >
            <Layout
              className={`layout-dashboard 
            }`}
            >
              <Sider
                trigger={null}
                width={200}
                theme="light"
                className={`sider-primary ant-layout-sider-primary ${
                  sidenavType === "#fff" ? "active-route" : ""
                }`}
                style={{ background: sidenavType }}
              >
                <Sidenav color={sidenavColor} />
              </Sider>
            </Layout>
          </Drawer>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onCollapse={(collapsed, type) => {}}
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
          <Layout className="content-layout">
            <div className="bg-[#F1F5F9] flex flex-col min-h-screen">
              {fixed ? (
                <Affix>
                  <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                    <Header
                      {...props}
                      mainProps={props.children}
                      onPress={openDrawer}
                      name={crumbName}
                      subName={subName || crumbName}
                      handleSidenavColor={handleSidenavColor}
                      handleSidenavType={handleSidenavType}
                      handleFixedNavbar={handleFixedNavbar}
                    />
                  </AntHeader>
                </Affix>
              ) : (
                <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                  <Header
                    {...props}
                    mainProps={props.children}
                    onPress={openDrawer}
                    name={crumbName}
                    subName={subName || crumbName}
                    handleSidenavColor={handleSidenavColor}
                    handleSidenavType={handleSidenavType}
                    handleFixedNavbar={handleFixedNavbar}
                  />
                </AntHeader>
              )}
              <Content className="content-ant flex-1 flex flex-col gap-y-2">
                {children}
              </Content>
              <Footer />
            </div>
          </Layout>
        </Layout>
        <Drawer
          title={drawerFilterHeader}
          placement={"right"}
          width={filterDrawerSize}
          // maskClosable={false}
          onClose={() => {
            dispatch(openDrawerFilter(false));
          }}
          open={showDrawerFilter}
        >
          {filterDrawerContent}
        </Drawer>
      </Spin>
    </Context.Provider>
  );
}

export default Main;
